<template>
  <div>
    <full-screen-spinner
      v-if="showLoader"
      spinner-text="Loading your favorites"
      top-margin="0px"
    />
    <div v-else-if="noFavs">
      <title-with-message
        title="No Homes Saved"
        message="Please perform a search and save your favorites"
        btn-option="Search Properties Now"
        @button-clicked="redirectToSearch()"
      />
    </div>
    <div v-else>
      <favorites-grid-layout
        :favorites="savedProperties"
        :client-data="clientData"
        :toured="touredProperties"
        @offer-message-sent="offerMessageSent($event)"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import FavoritesGridLayout from '../../components/client/favorites/FavoritesGridLayout.vue'
import FullScreenSpinner from '../../components/uiUtils/FullScreenSpinner.vue'
import TitleWithMessage from '../../components/uiUtils/TitleWithMessage.vue'
import {
  sortArrayBasedOnAnotherArray,
  sortObjectArrayByKey
} from '../../utils/generalUtils'
import { pastScheduledProperties } from '../../utils/routeUtils'

export default {
  components: { FavoritesGridLayout, FullScreenSpinner, TitleWithMessage },

  data() {
    return {
      showLoader: true,
      noFavs: false,
      savedProperties: [],
      touredProperties: []
    }
  },

  computed: {
    ...mapState('client', ['clientFavorites', 'clientHomes', 'clientData']),

    propertyDetails() {
      return this.clientFavorites.map(fav => fav)
    }
  },

  watch: {
    clientFavorites: {
      handler: function(newValue, oldValue) {
        if (this.clientData && newValue) {
          this.initProperties(this.clientData, newValue)
        }
      },
      deep: true
    }
  },

  created() {
    if (this.clientData && this.clientFavorites) {
      this.initProperties(this.clientData, this.clientFavorites)
    }
  },

  methods: {
    ...mapMutations('client', {
      saveClientFavorites: 'SAVE_CLIENT_FAVORITES'
    }),

    initProperties(clientData, clientFavs) {
      const { homes, routes } = clientData
      let touredArray = []
      let savedArray = []
      let touredArrayIds = []
      if (routes && routes.length > 0) {
        let { propertyIds, viewedTimes } = pastScheduledProperties(
          routes,
          true
        )
        touredArrayIds = [...propertyIds]
        touredArray = clientFavs.filter(fav => propertyIds.includes(fav._id))
        viewedTimes = sortObjectArrayByKey(viewedTimes, 'viewedTime', 'desc')
        touredArray = sortArrayBasedOnAnotherArray(
          touredArray,
          viewedTimes,
          '_id'
        )
      }
      this.touredProperties = touredArray

      if (homes && homes.length > 0) {
        savedArray = homes.filter(
          home => !touredArrayIds.includes(home.propertyId)
        )
        let savedFavs = clientFavs.filter(
          fav => !touredArrayIds.includes(fav._id)
        )
        this.savedProperties = this.timeSortedProperties(savedArray, savedFavs)
        if (savedArray.length === this.savedProperties.length) {
          this.showLoader = false
        }
      } else {
        this.noFavs = true
        this.showLoader = false
      }
    },

    offerMessageSent(data) {
      const updatedClientFavs = this.clientFavorites.map(home => {
        return home._id === data.propertyId
          ? { ...home, ...data, favoriteId: data._id, _id: home._id }
          : home
      })
      const updatedClientHomes = this.clientData.homes.map(home => {
        return home._id === data._id ? data : home
      })
      this.setClientData({ ...this.clientData, homes: [...updatedClientHomes] })
      this.saveClientFavorites(updatedClientFavs)
    },

    timeSortedProperties(homes, savedFavs) {
      if (homes.length > 0) {
        const tempArray = homes
          .sort((a, b) => (a._timestamp < b._timestamp ? 1 : -1))
          .map(item => item.propertyId)
        return sortArrayBasedOnAnotherArray(savedFavs, tempArray, '_id')
      }
      return []
    },

    redirectToSearch() {
      this.$router.push({ name: 'client-search' })
    }
  }
}
</script>
